import { RouteObject } from "react-router-dom";
import FieldForceLanding from "./components/fieldForceLanding/fieldForceLanding";
import FieldForceView from "./components/fieldForceView/fieldForceView";
import FieldForceEdit from "./components/fieldForceLanding/fieldForceEdit/fieldForceEdit";

export interface wxFieldForceRoutes extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: wxFieldForceRoutes[];
}
export const wxFieldForceRoutes: wxFieldForceRoutes[] = [
  {
    path: "/service-orders/field-force/",
    element: <FieldForceLanding />,
  },
  {
    path: "/service-orders/field-force/view/:id/:ff_no",
    element: <FieldForceView />,
  },
  {
    path: "/service-orders/field-force/edit/:id/:ff_no",
    element: <FieldForceEdit />,
  },
];
